import { FC } from 'react';

import { useGetGateTypeString } from '../../../../hooks/dictionaries/use-get-gate-type-string';
import { useTranslations } from '../../../../hooks/use-translations';

import { SelectForm, SelectFormProps } from './SelectForm';

type GateTypeSelectFormProps = Omit<SelectFormProps<'invoice' | 'withdraw' | ''>, 'options'> & {
  withEmpty?: boolean;
};

export const GateTypeSelectForm: FC<GateTypeSelectFormProps> = (props) => {
  const { withEmpty, ...selectProps } = props;

  const t = useTranslations('dictionaries.gateType');
  const getGateTypeString = useGetGateTypeString();

  return (
    <SelectForm
      {...selectProps}
      options={[
        ...(withEmpty ? ([{ value: '', name: t('all') }] as const) : []),
        ...(['invoice', 'withdraw'] as const).map((gateType) => ({
          name: getGateTypeString(gateType),
          value: gateType,
        })),
      ]}
    />
  );
};
